import { GlobalSearchResult } from "../types";

/**
 * Split results by what the server matched on: `search/global` reports a `name`
 * highlight when the name itself matched, so this is the API's own answer, not a
 * client-side re-match of the query.
 *
 * Only for callers that let the API match every field, which is the unscoped
 * app-wide search — they use the split to rank name matches first. A caller that
 * scopes its request with `queryBy` gets everything under nameMatches by
 * construction and should render results directly instead.
 */
export const partitionByNameMatch = (results: GlobalSearchResult[]) => {
  const nameMatches: GlobalSearchResult[] = [];
  const otherMatches: GlobalSearchResult[] = [];

  results.forEach((result) => {
    if (result.highlights && "name" in result.highlights) {
      nameMatches.push(result);
    } else {
      otherMatches.push(result);
    }
  });

  return { nameMatches, otherMatches };
};
